import {getMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/companyContract', request)
}

async function put(request) {
    return await putMethod('/api/companyContract', request)
}

export {get, put}
